import { render, staticRenderFns } from "./RccdP.vue?vue&type=template&id=0820466d"
import script from "./RccdP.vue?vue&type=script&lang=js"
export * from "./RccdP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports